
export default {
    name: 'BadgeDiscountIcon',
}
